export default __webpack_public_path__ + "static/verbatim_logo-8ac896e445279ac48de39fa430fb1a55.png";